<template>
  <div class="territory">
    <p class="title">
      选择地域级
    </p>
    <div class="territory-option">
      <!-- 区 -->
      <div class="option-content" @click="level_option(getPartnerlevelData[0].id)" :class="{'active-color':active_style==1}">
        <!-- 选项 -->
        <div class="option1">
          <p class="option1-title">
            {{getPartnerlevelData[0].level_name}}
          </p>
          <p>
            {{getPartnerlevelData[0].commission}}%佣金
          </p>
          <p>
            {{getPartnerlevelData[0].card_min/1000}}千-{{getPartnerlevelData[0].card_max/10000}}万张
          </p>
          <p>会员卡</p>
          <p>
            诚意金{{getPartnerlevelData[0].price/10000}}万元
          </p>
        </div>
        <!-- 奖励 -->
        <div class="award">
          <p class="award-title">
            奖励
          </p>
          <p class="award-content">
            康养积分:{{getPartnerlevelData[0].ky_points/1000}}千
          </p>
          <p class="award-content">
            岗位期权:{{getPartnerlevelData[0].job_options}}股
          </p>
          <p class="award-content">
            绩效期权:{{getPartnerlevelData[0].performance_options}}股
          </p>
        </div>
      </div>
      <!-- 县 -->
      <div class="option-content" @click="level_option(getPartnerlevelData[1].id)" :class="{'active-color':active_style==2}">
        <!-- 选项 -->
        <div class="option1">
          <p class="option1-title">{{getPartnerlevelData[1].level_name}}</p>
          <p>
            {{getPartnerlevelData[1].commission}}%佣金
          </p>
          <p>
            {{getPartnerlevelData[1].card_min/10000}}万-{{getPartnerlevelData[1].card_max/10000}}万张
          </p>
          <p>会员卡</p>
          <p>
            诚意金{{getPartnerlevelData[1].price/10000}}万元
          </p>
        </div>
        <!-- 奖励 -->
        <div class="award">
          <p class="award-title">
            奖励
          </p>
          <p class="award-content">
            康养积分:{{getPartnerlevelData[1].ky_points/1000}}千
          </p>
          <p class="award-content">
            岗位期权:{{getPartnerlevelData[1].job_options}}股
          </p>
          <p class="award-content">
            绩效期权:{{getPartnerlevelData[1].performance_options}}股
          </p>
        </div>
      </div>
      <!-- 市 -->
      <div class="option-content" @click="level_option(getPartnerlevelData[2].id)" :class="{'active-color':active_style==3}">
        <!-- 选项 -->
        <div class="option1">
          <p class="option1-title">{{getPartnerlevelData[2].level_name}}</p>
          <p>
            {{getPartnerlevelData[2].commission}}%佣金
          </p>
          <p>
            大于{{getPartnerlevelData[2].card_min/10000}}万张
          </p>
          <p>会员卡</p>
          <p>
            诚意金{{getPartnerlevelData[2].price/10000}}万元
          </p>
        </div>
        <!-- 奖励 -->
        <div class="award">
          <p class="award-title">
            奖励
          </p>
          <p class="award-content">
            康养积分:{{getPartnerlevelData[2].ky_points/1000}}千
          </p>
          <p class="award-content">
            岗位期权:{{getPartnerlevelData[2].job_options}}股
          </p>
          <p class="award-content">
            绩效期权:{{getPartnerlevelData[2].performance_options}}股
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      active_style : 0
    }
  },
  props:[
    'getPartnerlevelData'
  ],
  methods:{
    level_option(id){
      // console.log(id);
      this.active_style = id
      this.$emit('level_id',this.active_style)
    }
  }
}
</script>

<style lang="less" scoped>
  // 选择地域级
  .territory{
    width: 7.1rem;
    height: 6.38rem;
    margin: 0 auto;
    background: #fff;
    margin-top: .1rem;
    border-radius: .1rem;
    text-align: center;
    .title{
      font-size: 0.3rem;
      font-family: PingFang SC;
      font-weight: bold;
      color: #222222;
      line-height: .3rem;
      margin-top: .4rem;
    }
    // 地域选项
    .territory-option{
      display: flex;
      .option-content{
        &:first-child{
          margin-left: .56rem;
        }
        &:nth-child(2){
          margin-left: .4rem;
        }
        &:last-child{
          margin-left: .4rem;
        }
        // 选项1
        .option1 {
          width: 1.68rem;
          height: 2.1rem;
          border: 1px solid #E2E2E2;
          border-radius: .1rem;
          margin-top: .59rem;
          position: relative;
          .option1-title {
            width: .7rem;
            height: .3rem;
            border-radius: .15rem;
            background: #F5F5F5;
            margin: -10px auto 0;
            font-size: 0.22rem;
            font-family: PingFang SC;
            font-weight: 500;
            color: #A2A2A2;
            text-align: center;
          }
          p{
            &:nth-child(2){
              font-size: 0.22rem;
              font-family: PingFang SC;
              font-weight: 500;
              color: #222222;
              line-height: .22rem;
              margin-top: .14rem;
            }
            &:nth-child(3){
              font-size: 0.26rem;
              font-family: PingFang SC;
              font-weight: bold;
              color: #222222;
              margin-top: .34rem;
              line-height: .26rem;
            }
            &:nth-child(4){
              font-size: 0.22rem;
              font-family: PingFang SC;
              font-weight: 500;
              color: #A2A2A2;
              line-height: .22rem;
              margin-top: .09rem;
            }
            &:last-child{
              width: 100%;
              height: .51rem;
              background: #E2E2E2;
              font-size: 0.24rem;
              font-family: PingFang SC;
              font-weight: 500;
              color: #222222;
              text-align: center;
              position: absolute;
              bottom: 0;
              line-height: .51rem;
            }
          }
        }
        // 奖励
        .award{
          width: 1.68rem;
          height: 1.5rem;
          border: 1px solid #F4F4F4;
          border-radius: .1rem;
          text-align: center;
          margin-top: .27rem;
          // 奖励标题
          .award-title{
            font-size: 0.22rem;
            font-family: PingFang SC;
            font-weight: 500;
            color: #222222;
            line-height: .22rem;
            margin-top: .19rem;
          }
          .award-content{
            font-size: 0.22rem;
            font-family: PingFang SC;
            font-weight: 400;
            color: #A2A2A2;
            line-height: .22rem;
            margin-top: .1rem;
          }
        }
      }
      .active-color{
        .option1{
          .option1-title{
            background: #ffc201;
            color: #212121;
          }
          p{
            &:last-child{
              background: #ffc201;
              color: #FFFFFF;
            }
          }
        }
      }
    }
  }
</style>

